import React from 'react';

function Checkout(){
    return(
        <h2>
            Payment options coming soon.
        </h2>
    );
}
 
export default Checkout;